.container {
  display: flex;
  flex-direction: column;
}

.errorContainer {
  margin-top: 6px;
  font-size: 12px;
  line-height: 12px;

  .icon {
    font-size: 13px;
    color: var(--bc-color-error);
    margin-right: 5px;
  }
}

.datePicker {
  width: 100%;
  font-size: 14px;

  &.error {
    border-color: var(--bc-color-error);
  }

  :global {
    .ant-picker {
      &:hover {
        border: 1px solid var(--bc-color-border-secondary);

        &::placeholder, input::placeholder {
          color: var(--bc-color-text-tertiary);
        }
      }

      &:focus {
        border: 1px solid var(--bc-color-primary);
        background-color: var(--bc-color-bg-container);
        box-shadow: none;
      }

      &::placeholder, input::placeholder {
        color: var(--bc-color-text-secondary);
        font-size: 14px;
        font-family: var(--bc-font-family);
        font-weight: 400;
      }
    }
  }
}

.label {
  display: block;
  color: var(--bc-color-text-secondary);
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 12px;
  margin-bottom: 9px;
}
